import SectionedTable, { Row } from 'components/SectionedTable';
import RenderInvestmentDateCell from './RenderInvestmentDateCell';
import ConsiderationCell from './ConsiderationCell';
import { CONSIDERATION_ROWS } from './constants';
import {
  ConsiderationType,
  HoldingClassInvestmentsConsiderationValues,
} from '../../../types';
import { CurrencyCode } from 'further-types/lp/vehicle';

type InvestmentTableProps = {
  investmentId: string;
  investmentHoldingClasses: Array<HoldingClassInvestmentsConsiderationValues>;
  allHoldingClasses: Array<{ id: string; name: string }>;
  showHeader: boolean;
  currency: CurrencyCode;
  isFirst?: boolean;
  isLast?: boolean;
};

const InvestmentTable: React.FC<InvestmentTableProps> = ({
  investmentId,
  investmentHoldingClasses,
  allHoldingClasses,
  showHeader,
  currency,
  isFirst,
  isLast,
}) => {
  const investmentDate = investmentHoldingClasses[0]?.investmentDate;

  const columns = [
    {
      key: 'investmentDate',
      label: 'Investment Date',
      render: (row: Row) => (
        <RenderInvestmentDateCell row={row} investmentDate={investmentDate} />
      ),
    },
    {
      key: 'label',
      label: 'Unit Class',
    },
    ...allHoldingClasses.map((holdingClass) => ({
      key: holdingClass.id,
      label: holdingClass.name,
      render: (row: Row) => (
        <ConsiderationCell
          investmentHoldingClass={investmentHoldingClasses.find(
            (hc) => hc.holdingClassId === holdingClass.id,
          )}
          rowKey={row.key as ConsiderationType}
          currency={currency}
        />
      ),
    })),
  ];

  const investmentRows = CONSIDERATION_ROWS.map((row) => ({
    ...row,
    group: `investment_${investmentId}`,
  }));

  return (
    <SectionedTable
      key={investmentId}
      columns={columns}
      rows={investmentRows}
      headerColor="grey"
      showHeader={showHeader}
      noBorderTopRadius={!isFirst}
      noBorderBottomRadius={!isLast}
      hasGroupPadding={false}
    />
  );
};

export default InvestmentTable;
